'use client';
import { Button, Link } from '@mui/material';
import CtaButton from '../ctaButton';
import { trackEvent } from '../../../utils/trackEvent';
import { ButtonProps } from '@mui/material/Button';
import { useMemo } from 'react';
import { TBLinkType } from '../../../utils/mappers/link';
import { usePathname } from '../../../utils/routing';

type Props = ButtonProps & {
  cta?: TBLinkType;
  track?: {
    position?: string;
  };
};

const variantMap = {
  cta: 'contained',
  contained: 'contained',
  outlined: 'outlined',
  text: 'text',
  link: 'text',
} as const;

const RichCtaButton = ({ cta, track, ...rest }: Props) => {
  const pathname = usePathname();
  const href = useMemo(() => {
    let href = cta?.href || '#';
    if (pathname.split('/').length <= 2 && href.startsWith('/#')) {
      href = href.substring(1);
    }
    return href;
  }, [pathname, cta]);

  const commonProps = {
    color: rest.color || 'primary',
    href,
    onClick: (e: any) => {
      rest?.onClick?.(e);
      trackEvent('select_content', {
        content_type: 'cta',
        placement: track?.position,
        item_id: cta?.label,
      });
    },
  };

  const Component = cta?.appearance === 'cta' ? CtaButton : Button;
  if (cta?.appearance === 'link') {
    return <Link {...commonProps}>{cta.label}</Link>;
  }
  const isExternalLink = typeof href === 'string' && href.startsWith('http');

  return (
    <Component
      component={isExternalLink ? 'a' : Link}
      size={'large'}
      {...rest}
      {...commonProps}
      variant={variantMap[cta?.appearance || 'text']}
    >
      {cta?.label}
    </Component>
  );
};

export default RichCtaButton;
